import styled from 'styled-components';

export const Tag = styled.span`
  display: inline-block;
  padding: ${(props) => props.theme.spacing(0.5, 2)};
  background: ${(props) => props.theme.palette.grey[100]};
  border-radius: 500px;
  font-size: 12px;
  font-weight: bold;
  margin-right: ${(props) => props.theme.spacing(1)}px;
  margin-bottom: ${(props) => props.theme.spacing(1)}px;
`;
